import { EventEmitter, Injectable } from '@angular/core';
import { wenji } from 'libraries/interfaces/IWenji';
import { ApiResourceService } from 'libraries/service/apiResource/apiResource.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AirSearchResourceService {
    public airEndpoint: string = 'air';
    public tripsEndpoint: string = 'trips';
    public requestEndpoint: string = 'request';
    public onSearchIdTripChange: EventEmitter<string> = new EventEmitter<string>();

    public requestCache: Map<string, Observable<any>> = new Map();

    constructor(private readonly apiResourceService: ApiResourceService,) {
    }

    public getSearchRequest(idTrip: string): Observable<any> {
        if (!this.requestCache.has(idTrip)) {
            this.requestCache.set(
                idTrip,
                this.apiResourceService.getOne(
                    this.apiResourceService.getApiUrl(this.airEndpoint, this.tripsEndpoint, idTrip, this.requestEndpoint),
                    {},
                    {target: wenji.ui.target}
                ));
        }
        return this.requestCache.get(idTrip);
    }


}
